/**
 * Apa yang harus dilakukan saat Supabase mengabarkan sesi KOSONG — MURNI.
 *
 * ADA KARENA aplikasi ini memperlakukan setiap sesi kosong sebagai "sudah keluar", lalu jatuh ke
 * layar masuk tanpa mencoba apa pun. Owner melaporkannya sebagai "kenapa selalu sign out kalau
 * lama tidak dibuka" (27 Agustus 2026).
 *
 * Yang diukur di proyek Supabase saat itu: TIDAK ADA kedaluwarsa sesi sama sekali
 * (`sessions_timebox: 0`, `sessions_inactivity_timeout: 0`). Jadi server tidak mengeluarkan
 * siapa pun — yang mengeluarkan adalah kita sendiri, pada kegagalan yang sering kali SESAAT:
 * ponsel baru bangun dan jaringannya belum siap saat penyegaran token dicoba.
 *
 * PEMBEDAAN YANG MENENTUKAN: keluar yang DISENGAJA harus langsung, sementara sesi hilang yang
 * TIDAK disengaja pantas dicoba sekali lagi. Menyamakan keduanya berarti memilih salah satu
 * kesalahan: menahan orang yang menekan Keluar, atau menendang orang yang jaringannya berkedip.
 */
export type PutusanSesi = 'pertahankan' | 'coba-pulihkan' | 'keluar';

export function putusanSesi(
  event: string,
  adaSesi: boolean,
  sudahMencobaPulih: boolean,
): PutusanSesi {
  if (adaSesi) return 'pertahankan';

  /*
   * `SIGNED_OUT` = orangnya menekan Keluar, atau server menolak secara pasti. Dihormati apa
   * adanya; mencoba memulihkannya akan menahan orang yang baru saja menyerahkan perangkatnya.
   */
  if (event === 'SIGNED_OUT') return 'keluar';

  // Satu percobaan, bukan berulang: gagal dua kali berarti sesinya memang habis, dan mencoba
  // terus hanya menahan orang di layar yang tidak bergerak.
  return sudahMencobaPulih ? 'keluar' : 'coba-pulihkan';
}
